import {
  actions,
  addBookmarkAsync,
  removeBookmarkAsync,
  getBookmarksByContainerContentEntityIdAsync,
} from './slices';

export const BoolmarksActions = {
  ...actions,
  addBookmarkAsync,
  removeBookmarkAsync,
  getBookmarksByContainerContentEntityIdAsync,
};
